var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectiveInvoicesIssuedPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.638 37.483h-14.98a5.669 5.669 0 01-5.669-5.669V10.706a5.669 5.669 0 015.669-5.669h15.205a5.669 5.669 0 015.669 5.669v21.44"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 13.803,
    cy: 12.704,
    r: 1.444
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M25.173 15.732l3.068-2.987-2.988-3.068M27.281 12.732l-7.786-.026M13.881 22.822l2.423 2.112 2.328-2.031 2.372 2.069 2.502-2.182 2.498 2.178 2.634-2.297M13.881 29.645l2.423 2.112 2.328-2.03 2.372 2.068 2.502-2.182 2.498 2.178 2.634-2.297"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectiveInvoicesIssuedPlain);
export default __webpack_public_path__ + "static/media/correctiveInvoicesIssuedPlain.2d3e5eb5462dad7d169ca2d4715e0e4a.svg";
export { ForwardRef as ReactComponent };